// Fingerprint device identification on sign-in/sign-up. Only the event_id
// goes to the backend, which fetches the trusted visitor ID server-side.
export const FINGERPRINT_PUBLIC_API_KEY = "rDAt9nOViyJYnrrOX7KO";

export const FINGERPRINT_REGION = "us";

// Cloudflare proxy integration (worker on neuroscale.ai) so ad blockers don't
// block the agent. CSP allows only the proxy hosts (see lib/csp/csp.ts).
export const FINGERPRINT_ENDPOINT = "https://neuroscale.ai/uSHNFUApg3vTj6dc/";

// Upper bound on how long a sign-in click waits for identification.
export const FINGERPRINT_TIMEOUT_MS = 3000;

/**
 * SHA-256 hex of the trimmed, lowercased email, sent as an identification tag
 * on login so failed attempts are attributable in Fingerprint without sending
 * the raw address. Undefined when Web Crypto is unavailable.
 */
export async function hashEmail(email: string): Promise<string | undefined> {
  const normalized = email.trim().toLowerCase();
  if (!normalized || !globalThis.crypto?.subtle) return undefined;
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(normalized),
  );
  return Array.from(new Uint8Array(digest), (b) =>
    b.toString(16).padStart(2, "0"),
  ).join("");
}
